import {Injectable, NgZone} from '@angular/core';
import {each, find, forEach, get, isEmpty} from 'lodash';
import {HttpInterceptorService} from '../../core/services/http-interceptor.service';
import {ActivityService} from './activity.service';
import {AuthenticationService} from './authentication.service';
import {Observable, Subject, throwError} from 'rxjs';
import {bufferTime, catchError} from 'rxjs/operators';
import {DynamicSearchPayload, Filter, Relation, Target} from "@ispm-shared/modules/common/dynamic-search";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {NavigationEnd, Router} from "@angular/router";


@Injectable()
export class NotesService {
  private baseUrl = '/note';
  private _notePanelIsOpened = false;
  public editModeIsSupported = true;
  private triggerBundle$: Subject<any> = new Subject();
  private revisionIds: Array<Subject<any>> = []; // this is required to give index as observable

  constructor(
    private _http: HttpInterceptorService,
    public _authenticationService: AuthenticationService,
    private activityService: ActivityService,
    _zone: NgZone,
    private _ispmHttpClient: IspmHttpClient,
    private router: Router
  ) {
    _zone.runOutsideAngular(() => {
      this.triggerBundle$ // TODO buffer time as config
        .pipe(bufferTime(800))
        .subscribe(ids => {
          if (ids.length > 0) {
            _zone.run(() => {
              this.getBulkNotesFromServer(ids);
            });
          }
        });
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // handle successful navigation here
        forEach(this.revisionIds, function (revisionId) {
          revisionId.complete();// Make all the subject complete and then delete below
        });
        this.revisionIds = []; // On route change clean up the array of subjects automatically all the subscription closures will be freed
      }
    });
  }

  public revisionIdsReset(){
    this.revisionIds = [];
  }

  get notePanelIsOpened(): boolean {
    return this._notePanelIsOpened;
  }

  set notePanelIsOpened(value: boolean) {
    this._notePanelIsOpened = value;
  }

  public fixNoteText(text) {
    return text.replace(/^\s*(?:<p\s*><br\s*\/?\s*>\s*<\/p\s*>)+|(?:<p\s*><br\s*\/?\s*>\s*<\/p\s*>)+\s*$/g, '');
  }
  public save(note) {
    return this._http.post(this.baseUrl + '/', { note: note }).toPromise();
  }

  public update(note): any {
    return this._http.put(this.baseUrl + '/' + note.id, { note: note });
  }

  public get(context, actor): any {
    const params = {
      context: context,
      actor: actor
    };
    return this._http.get(this.baseUrl, params).map((data) => {
      // ngrxStoreService.dispatch({type: 'CURRENT_ORDER_SET_NOTES_DATA', payload: data.data});
      return data;
    });
  }
  public getWithContextType(contextId, contextType, actor, latestFirst = true){
    return this._http.get(this.baseUrl,
      {
        context: contextId,
        contextType: contextType,
        actor: actor,
        latestFirst: latestFirst,
        exact: contextType === 'WorkflowRequest'
          });
  }

  public toggleNotes(editModeIsSupported) {
    this.editModeIsSupported = editModeIsSupported !== undefined ? editModeIsSupported : true;
    this._notePanelIsOpened = !this._notePanelIsOpened;
  }

  public collapseNotes() {
    if (this._notePanelIsOpened) {
      this._notePanelIsOpened = false;
    }
  }

  public setNotesRead(notes) {
    let activities = [];

    each(notes, (note) => {
      if (!note.read) {
        activities.push(
          {
            actor: {
              reference: this._authenticationService.user.info.id,
              resourceType: note.actor.resourceType
            },
            context: [{
              reference: note.id,
              resourceType: 'Note'
            }],
            action: 'read'
          }
        )
      }
    });

    if (activities.length > 0) {
      this.activityService.create(activities)
        .subscribe(() => setTimeout(() => notes.setNotesUIRead(), 30000));
    }
  }

  public getBulkNote(revisionId): Observable<any> {
    this.triggerBundle$.next(revisionId);
    this.revisionIds[revisionId] = new Subject();
    return this.revisionIds[revisionId].asObservable();
  }

  public getBulkNotesFromServer(revisionIds:string[]) {
// This implementation looks little specific but making this DY search config as a payload won't add much value since all the worklist uses same these 3 sets of resources
    const filters:Filter[] = [];
    filters.push(new Filter('Activity', '=',  this._authenticationService.user.info.id, '{actor,reference}', 'reference'));
    filters.push(new Filter('Note', '=',  revisionIds.join(","), 'context', 'reference'));
    const relations:Relation[] = [];
    relations.push(new Relation("Note", 'Activity', '_revinclude', 'context', "ALL", 'id,meta,context,actor,action', 'left'));
    const dynamicSearchQuery:DynamicSearchPayload =  new DynamicSearchPayload( new Target("ALL",0,"id,text,tooltipText,context",false,false,false,false,true),relations,filters)
    this._ispmHttpClient.post('entity-tree/Note/dynamicSearch?type=clubbed', dynamicSearchQuery).pipe(catchError(err => {
      console.error('entity-tree/WorkflowRevision/dynamicSearch?type=clubbed is throwing error...', err.status,'-',err.message);
      return throwError(err);
    })).subscribe((response) =>{
      const data = get(response,'data');
      let noteAndActivity,activity = [];
      forEach(revisionIds, function (revisionId) {
        let workflowNotes = data.filter((item) => {
          return find(get(item,'context'), {reference: revisionId});
        });
        if(!isEmpty(workflowNotes)) {
          activity = workflowNotes.map(singleNote => get(singleNote,'Activity'));
          noteAndActivity = {notes:workflowNotes,Activity:activity};
          this.revisionIds[revisionId].next(noteAndActivity);
        } else {
          if(this.revisionIds[revisionId]) {
            this.revisionIds[revisionId].next('');
          }
        }

    }.bind(this));
  });
  }
}
